import { gql } from '@apollo/client';

const schema = {
  delete: {
    name: "deleteShopType",
    serviceName: "admin",
    query: gql`
      mutation deleteShopType($ids: [String]!) {
        deleteShopType(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
